import { MutableRefObject, ReactNode, useEffect, useRef, useState } from "react";
import './AnimatedChord.scss'
import { Music } from "../../Util/Music/Music";
import { HxMapGroup } from "../HxMap/HxMapGroup";
import { HexMap } from "../../Data/HexMap/HexMap";
import { BuildHexMap } from "../../Data/HexMap/HexMapBuilder";
import { TransformTranslate } from "../../Util/Transform/Transform";
import { HexMapModifier } from "../../Data/HexMap/HexMapModifier";
import { ChordShape } from "../ChordShapes/ChordShape";
import { Key } from "../../Data/HexMap/Key";
import { useNotePlayer } from "../../Sound/SoundStore";
import { Chords } from "../../Util/Music/Chords";
import { DotNav } from "../DotNav/DotNav";
import { NotePlayer } from "../../Sound/NotePlayer";


export interface AnimatedChordProps{
    rootPosition:number
    formula:number[]
    keyTonic:number
    radius:number
    onComplete?:Function
}
export function AnimatedChord(props:AnimatedChordProps){
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    const noteTonics:number[] = Music.getKeyScale(props.keyTonic)
    const width:number = props.radius * 2.8
    const height:number = props.radius * 2.8
    const getFormulaMax = () => {return props.formula[props.formula.length - 1]}
    const [position, setPosition] = useState<number>(-1)
    const [shape, setShape] = useState<ReactNode>(null)
    const getOffsetPosition = (pos:number) => {
        return (props.rootPosition + pos + 7) % 7
    }
    const getMapData = () => {
        let mapData:HexMap = BuildHexMap({columns:1, rows:1, tonic:props.keyTonic, radius:props.radius})
        const mod:HexMapModifier = new HexMapModifier(mapData)
        if(position >= 0){
            for(let i:number = 0; i < position + 1 && i <= getFormulaMax(); i++){
                const offsetPosition:number = getOffsetPosition(i)
                if(props.formula.includes(i)){
                    mod.notes_setHilited([offsetPosition])
                    mod.notes_setSecondaryLabel([offsetPosition], String(i + 1))
                }
                else if(position < getFormulaMax() + 1){
                    mod.notes_setSelected([offsetPosition])
                    mod.notes_setSecondaryLabel([offsetPosition], String(i + 1))
                }
            }
        }
        return mapData
    }
    const mapData:HexMap = getMapData()
    const getShape = () => {
        const parentKey:Key = mapData.keys.flat()[0]
        return  <ChordShape root={props.rootPosition} formula={props.formula} notes={mapData.notes} parentKey={parentKey}/>
    }
    const showShape = () => {
        setShape(getShape())
    }
    const getDotNavLength = () => {
        return props.formula[props.formula.length - 1] + 4
    }
    const onPositionSelect = (pos:number) => {
        const adjustedPosition:number = pos - 1
        if(adjustedPosition === position && position === getFormulaMax() + 1){
            playNote()
        }
        if(adjustedPosition < position){
            notePlayer.current.reset()
        }
        setPosition(adjustedPosition)
        if(adjustedPosition === getFormulaMax() + 2){
            showShape()
        }
        else{
            setShape(null)
        }
    }
    const getChordNotes = () => {
        return Chords.GetChordNoteTonics(props.keyTonic, props.rootPosition)
    }
    const playNote = () => {
        if(position === -1){return}
        const offsetPosition:number = getOffsetPosition(position)
        if(position <= getFormulaMax()){
            notePlayer.current.playNote(noteTonics[offsetPosition])
        }
        if(position === getFormulaMax() + 1){
            notePlayer.current.playChord(getChordNotes(), true)
        }
    }
    const resetNotePlayer = () => {
        notePlayer.current.reset()
    }
    const resetPosition = () => {
        setPosition(-1)
    }
    useEffect(playNote, [position])
    useEffect(resetNotePlayer, [props.rootPosition])
    useEffect(resetPosition, [props.keyTonic])
    return  <div>
                <svg width={width} height={height}>
                    <g className='group-container' transform={TransformTranslate(width/2, height/2)}>
                        <HxMapGroup classNames={['animated-chord']} hexMap={mapData}>
                            {shape}
                        </HxMapGroup>
                    </g>
                </svg>
                <div style={{marginTop:30}}>
                    <DotNav length={getDotNavLength()} selectedIndex={position + 1} onClick={onPositionSelect}/>
                 </div>
            </div>
}